export function formatFullAddress(
  address?: string,
  city?: string,
  state?: string,
  zip_code?: string,
) {
  let fullAddress = address || "";
  if (city) fullAddress += (fullAddress ? ", " : "") + city;
  if (state) fullAddress += (fullAddress ? ", " : "") + state;
  let zipPrefix = "";
  if (state || fullAddress) {
    zipPrefix = " ";
  }
  fullAddress += zipPrefix + zip_code;
  return fullAddress;
}
